var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Chip, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Brain01Icon, Delete02Icon, InformationCircleIcon, MoreHorizontalCircle01Icon, SortByUp01Icon } from 'hugeicons-react';
import useTranslate from '../../../../localization/helpers';
import { useState } from 'react';
import ProtectedElement from '../../../components/ProtectedElement';
import { Permissions } from '../../../permissions';
import { useGetDislikedConversationsQuery } from '../../../../application/features/chat/chat-api';
import { AppConsts } from '../../../../application/common/constants/app-consts';
import SortDrawer from '../../../components/sort-drawer';
var FeedbackCards = function (_a) {
    var conversations = _a.conversations, handleConversationDetails = _a.handleConversationDetails, onDeleteConversation = _a.onDeleteConversation, conversationsQuery = _a.conversationsQuery, setConversationsQuery = _a.setConversationsQuery;
    var theme = useTheme();
    var _b = useTranslate(), translate = _b.translate, tWithField = _b.tWithField;
    var _c = __read(useState(null), 2), anchorEl = _c[0], setAnchorEl = _c[1];
    var _d = __read(useState(null), 2), menuRowId = _d[0], setMenuRowId = _d[1];
    var _e = __read(useState(false), 2), openSortDrawer = _e[0], setOpenSortDrawer = _e[1];
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var _f = __read(useState(conversationsQuery.sortField), 2), sortField = _f[0], setSortField = _f[1];
    var _g = __read(useState(conversationsQuery.sortDirection), 2), sortDirection = _g[0], setSortDirection = _g[1];
    var _h = useGetDislikedConversationsQuery(conversationsQuery, {
        refetchOnMountOrArgChange: true
    }), sortedConversations = _h.data, isFetching = _h.isFetching;
    var sortOptions = [
        { value: 'date', label: translate('training.sortOptions.date') },
        { value: 'chatSource', label: translate('training.sortOptions.chatSource') },
        { value: 'status', label: translate('training.sortOptions.status') }
    ];
    var getChipColor = function (status) {
        switch (status) {
            case 'New':
                return 'default';
            case 'Resolved':
                return 'success';
            case 'Partially Resolved':
                return 'warning';
            default:
                return 'default';
        }
    };
    var translateStatus = function (status) {
        switch (status) {
            case 'New':
                return translate('training.new');
            case 'Resolved':
                return translate('training.resolved');
            case 'Partially Resolved':
                return translate('training.partiallyResolved');
            default:
                return status;
        }
    };
    var handleMenuClick = function (event, id) {
        setAnchorEl(event.currentTarget);
        setMenuRowId(id);
    };
    var handleMenuClose = function () {
        setAnchorEl(null);
        setMenuRowId(null);
    };
    var handleLoadMore = function () {
        if ((sortedConversations === null || sortedConversations === void 0 ? void 0 : sortedConversations.totalCount) &&
            conversationsQuery.pageSize < sortedConversations.totalCount) {
            setConversationsQuery(function (prev) { return (__assign(__assign({}, prev), { pageSize: prev.pageSize + AppConsts.DEFAULT_PAGE_SIZE })); });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', p: '0px 8px 8px 8px', position: 'relative', children: _jsxs(Box, { display: 'flex', gap: 0.5, alignItems: 'center', children: [_jsxs(Typography, { variant: 'subtitle2', children: [conversations.length, " ", translate('actions.items')] }), _jsx(IconButton, { size: 'Xs', onClick: function () { return setOpenSortDrawer(true); }, children: _jsx(SortByUp01Icon, {}) })] }) }), _jsxs(Box, { position: 'relative', display: 'flex', flexDirection: 'column', gap: 2, p: '0px 8px 8px 8px', sx: {
                    overflowY: 'auto',
                    maxHeight: isscreen600900Landscape
                        ? 'calc(100svh - 260px)'
                        : isIpadMini
                            ? 'calc(100svh - 331px)'
                            : 'calc(100svh - 313px)'
                }, children: [!isFetching && ((sortedConversations === null || sortedConversations === void 0 ? void 0 : sortedConversations.items.length) === 0 || conversations.length === 0) && (_jsxs(Box, { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: isscreen600900Landscape ? 0 : 8, px: 2, textAlign: 'center', children: [_jsx(Brain01Icon, { width: 48, height: 48, color: theme.palette.text.disabled }), _jsx(Typography, { variant: 'h6', color: 'text.secondary', mt: 2, children: tWithField('validations.notFound', 'common.training') })] })), !isFetching &&
                        ((sortedConversations === null || sortedConversations === void 0 ? void 0 : sortedConversations.items) || conversations).map(function (conversation) {
                            return (_jsxs(Box, { sx: {
                                    p: '8px 12px 16px 12px',
                                    boxShadow: theme.customShadows.z8,
                                    border: "2px solid ".concat('rgba(255, 255, 255, 1)'),
                                    borderRadius: theme.spacing(2),
                                    backgroundColor: theme.palette.background.paper,
                                    transition: 'border-color 0.3s ease'
                                }, children: [_jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsx(Typography, { variant: 'caption', color: theme.palette.text.tertiary, sx: {
                                                    maxWidth: '80%',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }, children: "by ".concat(conversation.chatBy) }), _jsxs(Box, { display: 'flex', alignItems: 'center', children: [_jsx(IconButton, { size: 'small', onClick: function (e) {
                                                            e.stopPropagation();
                                                            handleMenuClick(e, conversation.conversationId);
                                                        }, children: _jsx(MoreHorizontalCircle01Icon, {}) }), _jsx(IconButton, { size: 'small', color: 'primary', onClick: function (e) {
                                                            e.stopPropagation();
                                                            handleConversationDetails(conversation);
                                                        }, children: _jsx(InformationCircleIcon, {}) })] })] }), _jsx(SortDrawer, { open: openSortDrawer, onClose: function () { return setOpenSortDrawer(false); }, sortDirection: sortDirection, setSortDirection: setSortDirection, sortField: sortField, setSortField: setSortField, sortOptions: sortOptions, onApply: function () {
                                            var updatedFilters = __assign(__assign({}, conversationsQuery), { sortDirection: sortDirection, sortField: sortField, page: AppConsts.DEFAULT_PAGE_NUMBER });
                                            setConversationsQuery(updatedFilters);
                                            setOpenSortDrawer(false);
                                        }, backdropColor: 'rgba(22, 28, 36, 0.3)' }), _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 1, children: [_jsx(Typography, { variant: 'body1', sx: {
                                                    maxWidth: '80%',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }, children: conversation.conversationName }), _jsxs(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center', children: [_jsx(Typography, { variant: 'body2', color: theme.palette.text.secondary, sx: {
                                                            maxWidth: '80%',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap'
                                                        }, children: conversation.machines }), _jsx(Chip, { label: translateStatus(conversation.status), color: getChipColor(conversation.status), variant: 'soft', size: 'medium' })] }), _jsxs(Box, { display: 'flex', flexDirection: 'row', gap: 0.5, children: [_jsx(Typography, { variant: 'caption', color: theme.palette.text.tertiary, sx: {
                                                            maxWidth: '80%',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap'
                                                        }, children: new Date(conversation.date).toLocaleDateString(translate('common.dateLanguageCode1'), {
                                                            month: 'short',
                                                            day: 'numeric',
                                                            year: 'numeric'
                                                        }) }), _jsx(Typography, { variant: 'caption', color: theme.palette.text.tertiary, sx: {
                                                            maxWidth: '80%',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap'
                                                        }, children: new Date(conversation.date).toLocaleTimeString(translate('common.dateLanguageCode2'), {
                                                            hour12: true,
                                                            hour: '2-digit',
                                                            minute: '2-digit'
                                                        }) })] })] }), _jsx(Menu, { anchorEl: anchorEl, open: menuRowId === conversation.conversationId, onClose: handleMenuClose, anchorOrigin: {
                                            vertical: 'bottom',
                                            horizontal: 'center'
                                        }, transformOrigin: {
                                            vertical: 'top',
                                            horizontal: 'center'
                                        }, children: _jsx(ProtectedElement, { permissions: [Permissions.Training.Delete], children: _jsxs(MenuItem, { sx: { color: theme.palette.error.main }, onClick: function () {
                                                    handleMenuClose();
                                                    onDeleteConversation(conversation);
                                                }, children: [_jsx(ListItemIcon, { sx: { color: 'inherit' }, children: _jsx(Delete02Icon, { color: 'inherit', fontSize: 'small' }) }), _jsx(ListItemText, { children: translate('actions.delete') })] }) }) })] }, conversation.conversationId));
                        }), (sortedConversations === null || sortedConversations === void 0 ? void 0 : sortedConversations.totalCount) &&
                        conversationsQuery.pageSize < sortedConversations.totalCount &&
                        !(sortedConversations.totalCount - conversationsQuery.page * conversationsQuery.pageSize <
                            0) && (_jsx(Button, { variant: 'outlined', fullWidth: true, onClick: handleLoadMore, disabled: isFetching, children: isFetching
                            ? translate('common.loading')
                            : translate('common.loadMore', {
                                count: sortedConversations.totalCount -
                                    conversationsQuery.page * conversationsQuery.pageSize
                            }) }))] })] }));
};
export default FeedbackCards;
